<template>
  <div class="qrcode">
    <div v-if="qrValue">
      <qrcode-vue :value="qrValue" class="qrcode orientation-landscape" :size="($q.screen.lt.sm) ? 200 : 250" level="H"/>
      <qrcode-vue :value="qrValue" class="qrcode orientation-portrait" :size="($q.platform.is.safari) ? 350 : 250" level="H"/>
      <LastAdded v-if="cu" :userId="cu" :isAnonymous="isAnonymous" :key="cu" @update-points="callback" @connected="connected" />
      <div class="text-subtitle1 q-ma-sm" v-if="isAnonymous">
        This code will only work in this browser. 
        Create an account and make it yours.
      </div>
    </div>
    <div class="q-pa-md row justify-center" v-else>
      <Spinner v-if="loadingNew"/>
      <img src="/assets/icons/qr-home-dig.svg" width="250" alt="Default" @click="generateToken()" v-if="!loadingNew"/>
      <q-btn class="full-width square q-my-sm" label="Create my code" @click="generateToken()" :loading="loadingNew" color="primary" size="md" />
      <p class="error" v-if="errorMsg">{{errorMsg}}</p>
      <recaptcha @callback="newQr" ref="recaptcha" />
    </div>
    <SignInBar cssclass="signin-bar" v-if="!loadingNew" :logged="logged" />
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'
import {inject, ref, watch} from "vue";
import VueCookies from 'vue-cookies'
// import useSignupAnonymous from "@/composables/useSignupAnonymous";
import Spinner from "@/components/Spinner";
import SignInBar from "@/components/SignInBar";
import LastAdded from "@/components/LastAdded";
import Recaptcha from "@/components/Recaptcha";
import { useStore } from 'vuex';

export default {
  name: "QrCodeCustomer",
  components:{SignInBar, Spinner, QrcodeVue, LastAdded, Recaptcha},
  props: ['qrValue', 'userId', 'logged', 'callback'],
  setup(props, context) {
    const loadingNew = ref(false)
    const errorMsg = ref('')
    const cu = ref(props.userId)
    const key = ref(0)
    const isAnonymous = ref(false)
    const store = useStore()
    const axios = inject('axios')
    VueCookies.config('5y')
    const recaptcha = ref(null)
    const tooltip = ref(false)
    
    const newQr = async (token) => {
      loadingNew.value = true
      axios.post(`${process.env.VUE_APP_URL}/users`, {token: token})
      .then(async resp=>{
        cu.value = resp.data.id
        VueCookies.set('anonymousGuid', resp.data.anonymousGuid)
        isAnonymous.value = true
        store.commit('setUser', resp.data)
        let response = await store.dispatch('anonymousLogin', resp.data.anonymousGuid)
        context.emit('anonimous-signin', resp.data.id)
        loadingNew.value = false
      })
      .catch((err) => {
        loadingNew.value = false
        errorMsg.value = err.message
      })
    }

    const connected = (event) => {
      store.commit('setConnected', event)
    }

    const generateToken = () => {
      recaptcha.value?.execute()
    }

    watch(tooltip, () => {
      console.debug('Teste', tooltip.value)
    })

    isAnonymous.value = store.getters.isAnonymous
    
    return {newQr, loadingNew, errorMsg, cu, isAnonymous, connected, generateToken, key, recaptcha, tooltip}
  }
}
</script>

<style scoped>
@media only screen and (orientation:landscape) and (hover: none) and (pointer: coarse) {
  .signin-bar { display:none; }
}
/* Show place card when portrait */
@media only screen and (orientation:portrait) and (hover: none) and (pointer: coarse) {
  .signin-bar { display:block; }
}
.qrcode {
  margin: 0 auto;
  max-width: 350px;
}
.qrcode img{
  cursor: pointer;
}
</style>